import { Scale, Bell, Radio, MessageSquare, History, Tags } from 'lucide-react';

export const rulesSecondarySidebar = {
  enabled: true,
  title: 'مدیریت قوانین',
  items: [
    {
      id: 'alert',
      label: 'هشدارهای فعال',
      icon: Bell,
      path: '/rules?tab=alert',
      description: 'مدیریت هشدارهای فعال',
    },
    {
      id: 'message',
      label: 'پیام‌ها',
      icon: MessageSquare,
      path: '/rules?tab=message',
      description: 'مدیریت و مشاهده پیام‌ها',
      activePaths: ['/rules/message/:messageId'],
    },
    {
      id: 'history',
      label: 'تاریخچه هشدارها',
      icon: History,
      path: '/rules?tab=history',
      description: 'مشاهده سوابق و تاریخچه هشدارها',
    },
    {
      id: 'rule',
      label: 'قوانین',
      icon: Scale,
      path: '/rules?tab=rule',
      description: 'مدیریت قوانین و شرایط',
      activePaths: ['/rules/create', '/rules/:ruleId'],
    },
    {
      id: 'channel',
      label: 'کانال‌ها',
      icon: Radio,
      path: '/rules?tab=channel',
      description: 'تنظیمات کانال‌های ارتباطی',
    },
    {
      id: 'tag',
      label: 'تگ‌ها',
      icon: Tags,
      path: '/rules?tab=tag',
      description: 'گروه‌بندی دستگاه‌ها',
    },
  ],
};
